import './faqs-block.scss';

export default () => {
	const jsScrollLinks = document.querySelectorAll('.js-scroll');
	jsScrollLinks.forEach(link => {
		link.addEventListener('click', function (e) {

			e.preventDefault();

			jsScrollLinks.forEach(item => item.classList.remove('is-active'));

			this.classList.toggle('is-active');

			const target = document.querySelector(this.getAttribute('href'));

			if (target) {
				const scrollTo = target.offsetTop - 50;
				window.scrollTo({
					top: scrollTo,
					behavior: 'smooth',
				});
			}
		});
	});

};
